import React from 'react';
import SuiviHeader from '../../../composants/SuiviHeader/SuiviHeader';
import { getStatusColor } from '../../../utils/entityUtils';
import { OperationBCI } from '../types';

interface OperationHeaderProps {
  operation: OperationBCI;
  backgroundImage?: string;
  onRetour?: () => void;
}

// Banniere acheteur-BC : delegue au generique SuiviHeader (meme composant que le MS), config
// source="BC". SuiviHeader gere en interne l'expiration, le libelle "A relancer" (statut 12)
// et le chrono (statut 11). Le libelle/couleur du statut viennent du nom + getStatusColor.
const OperationHeader: React.FC<OperationHeaderProps> = ({ operation, backgroundImage, onRetour }) => (
  <SuiviHeader
    titre={operation.nom || ''}
    sousTitre={''}
    subtitle={`${operation.lot_technique?.id ?? ''} - ${operation.lot_technique?.nom ?? ''}, ${operation.id_lot_departement ?? ''} - ${operation.lot_departement?.departement?.nom ?? ''}`}
    status={operation.status?.nom || 'Statut inconnu'}
    statusColor={getStatusColor(operation.status?.nom || '')}
    delais={operation.expire_at}
    backgroundImage={backgroundImage}
    source="BC"
    statusId={operation.status?.id}
    onRetour={onRetour}
  />
);

export default OperationHeader;
